import { MultiAddOnSelector } from '@moonpig/web-shared-products'
import React, { FC } from 'react'
import { Box } from '@moonpig/launchpad-components'
import { useProductContext } from '../../../contexts/product'
import { ProductWithRecommendations } from '../../../components/ProductDetails'
import { ProductDetailsStateActionTypes } from '../../../contexts/product/types'
import { ProductModuleSection } from '../ProductModuleSection'
import { ProductModule } from '../types'

const CONTAINER_XS_PX = 6

const getSelectedVariant = ({
  product,
  variantKey,
}: {
  product: ProductWithRecommendations
  variantKey: string
}) => {
  return product.variants.find(v => v.key === variantKey)
}

export const AddOnSelectorModule: FC<ProductModule> = props => {
  const [{ product, selectedOptions }, dispatch] = useProductContext()

  const selectedVariant = getSelectedVariant({
    product,
    variantKey: selectedOptions.variantKey,
  })
  const addons = (selectedVariant?.addons || []).filter(
    ({ inStock }) => inStock,
  )
  const selectedAddon = addons.find(
    ({ sku }) => sku === selectedOptions.addonSku,
  )

  if (!addons.length) {
    return null
  }

  return (
    <ProductModuleSection {...props}>
      <Box
        bgcolor="colorBackground06"
        py={8}
        px={{ xs: CONTAINER_XS_PX, lg: 8 }}
        mx={{ xs: -CONTAINER_XS_PX, md: 0 }}
      >
        <MultiAddOnSelector
          addons={addons}
          selectedAddon={selectedAddon}
          onAddClick={({ sku }) => {
            dispatch({
              type: ProductDetailsStateActionTypes.SET_ADDON_SKU,
              payload: sku,
            })
          }}
          onRemoveClick={() => {
            dispatch({
              type: ProductDetailsStateActionTypes.SET_ADDON_SKU,
              payload: null,
            })
          }}
        />
      </Box>
    </ProductModuleSection>
  )
}
